import React from "react";
import KenInputField from "../KenInputField";
import KenSelect from "../KenSelect";

export default function KenInputMobile(props) {
  const {
    label,
    inputName,
    onchangeInput,
    inputvalue,
    errors,
    touched,
    options,
    countrycodeValue,
    selectName,
    onChangeSelect,
    setFieldValue,
    defaultCountryCode,
  } = props;

  //setFieldValue is required for default value

  return (
    <KenInputField
      {...props}
      required={false}
      label={label}
      name={inputName}
      startAdornment
      onChange={onchangeInput}
      value={inputvalue}
      errors={errors}
      touched={touched}
      startAdornmentIcon={
        <div style={{ marginTop: "-2px", marginBottom: "-4px" }}>
          <KenSelect
            // {...props}
            required={false}
            options={options}
            value={countrycodeValue}
            name={selectName}
            onChange={onChangeSelect}
            defaultValue={() => {
              if (setFieldValue) {
                setFieldValue(selectName, defaultCountryCode);
              }
              return defaultCountryCode;
            }}
          />
        </div>
      }
    />
  );
}
